import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import type Result from 'true-myth/result';

import { ApplicationContext } from '../context/context';
import type { Pathname } from '../http-fetcher/http-fetcher';

export const useDeleteProfile = (
    onDeleteProfileSuccess: () => void,
): UseMutationResult<Result<unknown, Error>, unknown, void> => {
    const { cobrainerApiFetcher } = useContext(ApplicationContext);
    const pathname: Pathname = '/users/me';

    return useMutation({
        mutationFn: async () => {
            const result = await cobrainerApiFetcher.delete({
                pathname,
            });

            if (result.isOk) {
                return result;
            }

            throw result.error;
        },
        mutationKey: [pathname, 'delete'],
        onSuccess: onDeleteProfileSuccess,
    });
};
